import { useEffect, useMemo } from 'react';
import { Table, Message, Loader } from 'semantic-ui-react';
import { useFilters, useSortBy, usePagination, useTable } from 'react-table';
import styled from 'styled-components';
import TableStylesCompact from './TableStylesCompact';
import PaginationSection from './PaginationSection';
import DefaultColumnFilterControlled from './DefaultColumnFilterControlled';

const CustomTable = styled(Table)`
	margin : 0 0 .3em 0 !important;
	width : 100%;
`;

const TableWrapper = styled.div`
`;

const PaginationWrapper = styled.div`
	position : relative;
`;

const CenterMessage = styled(Message)`
	text-align: center;
`;

const FilterTH = styled.th`
	text-align : center !important;
	padding : 5px !important;
`;

const HeaderTH = styled.th`
	padding: 10px 5px !important;
`;

function ServerPaginatedTable({ columns, data = [], current_project_id, selected_filter = null, fetchTableData, loading, default_page_size, pageCount : controlledPageCount, styles, hidden_columns = [] }) {
	const defaultColumn = useMemo(() => ({
		Filter: DefaultColumnFilterControlled,
	}), []);

	const {
		getTableProps,
		getTableBodyProps,
		headerGroups,
		prepareRow,
		page,

		canPreviousPage,
		canNextPage,
		pageCount,
		gotoPage,
		nextPage,
		previousPage,
		state : { pageIndex, pageSize, filters, sortBy }
	} = useTable(
		{
			columns,
			data,
			defaultColumn,
			initialState     : { pageIndex : 0, pageSize : default_page_size, hiddenColumns : hidden_columns },
			manualPagination : true,
			manualFilters    : true,
			manualSortBy     : true,
			pageCount        : controlledPageCount,
		},
		useFilters,
		useSortBy,
		usePagination
	);

	/* eslint-disable */
	useEffect(() => {
		fetchTableData({ pageIndex, pageSize, filters, sortBy })
	}, [pageIndex, filters, sortBy, current_project_id, selected_filter]);
	/* eslint-enable */

	return (
		<TableStylesCompact>
			<TableWrapper style={styles}>
				<CustomTable striped celled {...getTableProps()}>
					<thead>
						{headerGroups.map((headerGroup, i) => (
							<tr {...headerGroup.getHeaderGroupProps} key={`${i}-a`}>
								{headerGroup.headers.map(column => (
									<HeaderTH {...column.getHeaderProps(column.getSortByToggleProps())}>
										{column.render('Header')}
									</HeaderTH>
								))}
							</tr>
						))}

						{headerGroups.map((headerGroup, i) => (
							<tr {...headerGroup.getHeaderGroupProps} key={`${i}-b`}>
								{headerGroup.headers.map(column => (
									<FilterTH {...column.getHeaderProps()}>
										{column.canFilter ? column.render('Filter') : null}
									</FilterTH>
								))}
							</tr>
						))}
					</thead>

					<TableBody
						data={data}
						loading={loading}
						getTableBodyProps={getTableBodyProps}
						page={page}
						prepareRow={prepareRow}
						headerGroups={headerGroups}
					/>
				</CustomTable>

				<PaginationWrapper>
					<PaginationSection
						page_count={pageCount}
						page_index={pageIndex}
						can_next_page={canNextPage}
						can_previous_page={canPreviousPage}
						nextPage={nextPage}
						previousPage={previousPage}
						gotoPage={gotoPage}
					/>
				</PaginationWrapper>
			</TableWrapper>
		</TableStylesCompact>
	);
}

function TableBody({ loading, data, getTableBodyProps, page, prepareRow, headerGroups}) {
	const colspan = headerGroups[0].headers.length;

	if(!loading && data.length) {
		return (
			<Table.Body {...getTableBodyProps()}>
				{page.map((row, i) => {
					prepareRow(row)

					return (
						<tr {...row.getRowProps()} key={i}>
							{row.cells.map(cell => {
								return <td {...cell.getCellProps()}>{cell.render('Cell')}</td>
							})}
						</tr>
					)
				})}
			</Table.Body>
		);
	}
	else if(!loading && !data.length) {
		return (
			<Table.Body>
				<tr>
					<td colSpan={colspan}>
						<CenterMessage>No records found</CenterMessage>
					</td>
				</tr>
			</Table.Body>
		);
	}
	else {
		return (
			<Table.Body>
				<tr>
					<td colSpan={colspan}>
						<Loader active inline="centered" />
					</td>
				</tr>
			</Table.Body>
		);
	}
}

export default ServerPaginatedTable;
